import PartialContent from './PartialContent.component';

export default PartialContent;